export default "__VITE_ASSET__fuB8$Z6p__"